export const NITRO_CLAW_MESH = {
    colors: [
        '#eb75b6',
        '#ddf3ff',
        '#6e3deb',
        '#c92f3c'
    ],
    meshId: 757
};
export const NITRO_ANALYSTS_MESH = {
    colors: [
        '#0033ff',
        '#6f3467',
        '#b8fff7',
        '#66d1ff'
    ],
    meshId: 527
};
export const MIGRATION_AGENTS_MESH = {
    colors: [
        '#4dffb2',
        '#ddf3ff',
        '#0ff5da',
        '#507ce2'
    ],
    meshId: 679
};
export const WORKFORCE_AGENTS_MESH = {
    colors: [
        '#1ac737',
        '#fdff80',
        '#18d6fb',
        '#008f58'
    ],
    meshId: 578
};
export const RM_AGENTS_MESH = {
    colors: [
        '#ff4d4d',
        '#fff2db',
        '#fbff1a',
        '#ff7024'
    ],
    meshId: 903
};
export const DOCUMENTATION_AGENTS_MESH = {
    colors: [
        '#7c5cff',
        '#ffe8cc',
        '#a78bfa',
        '#3b82f6'
    ],
    meshId: 812
};
export const NITRO_BREWS_MESH = {
    colors: [
        '#ff004c',
        '#ffdb9e',
        '#00d6b3',
        '#66d1ff'
    ],
    meshId: 405
};
